<template>
  <div class="acknowledgement-view">
    <section id="acknowledgement-wrap" class="section">
      <div class="container">
        <div class="row">
          <div class="align-col-center col-md-12">
            <h1>Open source software licenses and acknowledgements</h1>
            <p>
              During your interaction with this web-site you may receive open
              source software that is being executed within your browser.
              <br />The below overview provides open source software that you
              may receive from our web-site.
            </p>
            <div v-for="(value, key) in content" v-bind:key="key">
              <br />
              <br />
              Package name: {{ key }} <br /><br />
              NOTICE:<br />
              {{ value.notice }}
              <br /><br />
              License:<br />
              {{ value.licenseText }}
              <br />
              <a v-bind:href="value.source_url" v-if="value.source_url" download
                >Download source code</a
              >
              <br />
              =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
            </div>
          </div>
        </div>
      </div>
    </section>
    <landingFooter></landingFooter>
  </div>
</template>

<script>
import landingFooter from "./layout/Footer.vue";
import jsonDataFrontend from "@/assets/json/frontend.json";
import jsonDataAdminFrontend from "@/assets/json/admin-frontend.json";
import jsonDataStyleguide from "@/assets/json/styleguide.json";

const all = Object.assign(
  jsonDataFrontend,
  jsonDataAdminFrontend,
  jsonDataStyleguide
);

export default {
  name: "LandingView",
  components: {
    landingFooter,
  },
  data() {
    return {
      content: all,
    };
  },
  computed: {
    filteredPackages: function () {
      let lookupObject = {};

      for (let i in this.content) {
        lookupObject[this.content[i]["name"]] = this.content[i];
      }

      return this.content;
    },
  },
};
</script>

<style lang="scss" scoped>
$bg-gray: #eaeaea;

.acknowledgement-view {
  overflow-x: hidden;
  position: relative;
  flex-grow: 2;

  $sectionPadding: 60px;

  .section {
    padding: $sectionPadding 0;

    &.section-branding {
      padding: 0;

      .col {
        padding-top: $sectionPadding;
        padding-bottom: $sectionPadding;
      }
    }
  }
}

.bg-gray {
  background-color: $bg-gray;
}

h1 {
  font-size: 42px;
}

h2 {
  margin-bottom: 2rem;
  color: #3c3c41;
  font-size: 34px;
}

.container-fluid {
  overflow: hidden;
}

p {
  color: #3c3c41;
}

label {
  width: 100%;
  position: relative;

  .search-input {
    padding-left: 36px;
  }

  .search-icon {
    width: 16px;
    position: absolute;
    top: 13px;
    left: 12px;
    cursor: pointer;

    path {
      fill: $dark-gray-800;
    }
  }

  .cross-icon {
    width: 16px;
    position: absolute;
    top: 13px;
    right: 12px;
    cursor: pointer;

    path {
      fill: $dark-gray-800;
    }
  }
}

.search-box {
  display: flex;
  flex-flow: row wrap;

  h6 {
    flex: 1 100%;
  }

  label {
    margin: 0 16px 0 0;
    flex: 4 0 0;
  }

  input {
    flex: 1 0 0;
  }
}

button {
  max-width: 175px;
  width: 100%;
}

.align-col-center {
  align-self: center;
}

.align-col-bottom {
  margin-top: auto;
}

.intro {
  flex-flow: column nowrap;

  .row {
    &:first-child {
      padding: 0;
    }
  }

  .buttons {
    button {
      &:first-child {
        margin: 0 1rem 0 0;
      }
    }
  }
}
</style>
